import { combineReducers } from "redux";
import { statusesReducer } from "./statusesReducer";
import { pathologyReducer } from "./pathologyReducer";
import { uploadReducer } from "./uploadReducer";
import { userReducer } from "./userReducer";

export const rootReducer = combineReducers({
  statuses: statusesReducer,
  pathology: pathologyReducer,
  upload: uploadReducer,
  user: userReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
